type MessageLike = { message?: unknown };

export function toAdminInsertUserDisplayMessage(
  value: unknown,
  fallback: string
): string {
  if (typeof value === "string" && value.trim()) {
    return value;
  }

  if (value && typeof value === "object" && "message" in value) {
    const nested = (value as MessageLike).message;
    if (typeof nested === "string" && nested.trim()) {
      return nested;
    }
  }

  return fallback;
}

export function hasAdminInsertUserFailures(failures: unknown): boolean {
  if (failures == null || failures === false) {
    return false;
  }
  if (Array.isArray(failures)) {
    return failures.length > 0;
  }
  if (typeof failures === "object") {
    return Object.keys(failures).length > 0;
  }
  return Boolean(failures);
}

export function getAdminInsertUserResultMessage(
  result: { message?: unknown; failures?: unknown } | null | undefined,
  fallback: string
): string {
  const fromMessage = toAdminInsertUserDisplayMessage(result?.message, "");
  if (fromMessage) {
    return fromMessage;
  }

  const failures = result?.failures;
  if (Array.isArray(failures) && failures.length > 0) {
    const fromFirstFailure = toAdminInsertUserDisplayMessage(failures[0], "");
    if (fromFirstFailure) {
      return fromFirstFailure;
    }
    if (typeof failures[0] === "string") {
      return failures[0];
    }
  }

  return fallback;
}
